import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";
import { useTranslate } from "src/locales/use-locales";
import { Box, Stack } from "@mui/material";

interface RadioButtonProps extends React.ComponentProps<typeof Radio> {
  typographyText: string;
  layout: "row" | "column";
  border?: string;
  fontSize?: string | number;
  maxWidth?: string;
  textAlign?: string;
}


export const ByzMuiRadioButton = ({
  typographyText,
  layout,
  border = "none",
  fontSize,
  maxWidth = "300px",
  textAlign,
  ...props
}: RadioButtonProps) => {
  const [selectedValue, setSelectedValue] = useState<string>("");
  const textArray = typographyText.split(",");
  const { t } = useTranslate();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: layout,
        },
        gap: border ? 1 : 0,
        border: border === "none" ? "none" : border || "1px solid #2196F3",
        padding: border ? "10px" : 0,
        borderRadius: border ? "5px" : 0,
        maxWidth: maxWidth !== "none" ? maxWidth : undefined,
        width: "100%",
      }}
    >
      {textArray.map((text, index) => (
        <Stack
          key={index}
          direction="row"
          alignItems="center"
          sx={{ width: "auto", gap: "0px" }}
          //spacing={0.2}
          //sx={{ width: "auto" }}
        >
          <Radio
            {...props}
            value={t(text)}
            checked={selectedValue === t(text)}
            onChange={handleChange}
            sx={{
              alignSelf: "center",
              verticalAlign: "middle",
              padding: "1px",
              marginRight: "0px",
              ...props.sx,
            }}
          />
          <ByzMuiTypography
            sx={{
              fontWeight: 400,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: fontSize ? fontSize : "13px",
              ...(textAlign ? { textAlign: textAlign } : {}),

            }}
          >
            {t(text)}
          </ByzMuiTypography>
        </Stack>
      ))}
    </Box>
  );
};

export default ByzMuiRadioButton;
